import instance from "../../../services/api";

export const contragentAvrApi = {
  list(remontId) {
    return instance(true)
      .get(`/partner/remont/${remontId}/contragent_avr/list/`)
      .then((res) => res?.data);
  },

  listContractorAgreementForAvrModal(remontId) {
    return instance(true)
      .get(
        `/partner/remont/${remontId}/contragent_avr/contractor-agreement-for-avr-modal/list/`
      )
      .then((res) => res?.data);
  },

  create(body) {
    return instance(true)
      .post(`/partner/contragent_avr/create/`, body)
      .then((res) => res?.data);
  },

  sign(contragentAvrId, body) {
    return instance(true)
      .post(`/partner/contragent_avr/sign/${contragentAvrId}/`, body)
      .then((res) => res?.data);
  },

  downloadSignedAvr(contragentAvrId) {
    return instance(true, null, { showToast: false, throwError: true }).get(
      `/partner/contragent_avr/download-signed-avr/${contragentAvrId}/`,
      { responseType: "blob" }
    );
  },
};
